import React from 'react';
import ModernRegisterSale from './ModernRegisterSale';

const RegisterSale = () => {
    return <ModernRegisterSale />;
};

export default RegisterSale;